import { locate } from "./html";

let counter = (new Date()).valueOf();
export function uid(): string {
	return "u" + (counter++);
}

export function extend(target, source, deep = true) {
	if (source) {
		for (const key in source) {
			const sobj = source[key];
			const tobj = target[key];
			if (deep && typeof tobj === "object" && !(tobj instanceof Date) && !(tobj instanceof Array)) {
				extend(tobj, sobj);
			} else {
				target[key] = sobj;
			}
		}
	}
	return target;
}

interface IOBj {
	[key: string]: any;
}
export function copy(source: IOBj, withoutInner?: boolean): IOBj {
	const result: IOBj = {};
	for (const key in source) {
		if (!withoutInner || key[0] !== "$") {
			result[key] = source[key];
		}
	}
	return result;
}

export function naturalSort(arr): any[] {
	return arr.sort((a: any, b: any) => {
		const nn = typeof a === "string" ? a.localeCompare(b) : a - b;
		return nn;
	});
}

export function findIndex<T = any>(arr: T[], predicate: (obj: T) => boolean): number {
	const len = arr.length;
	for (let i = 0;i < len;i++) {
		if (predicate(arr[i])) {
			return i;
		}
	}
	return -1;
}

export function isEqualString(from: string, to: string): boolean {
	if (from.length > to.length) {
		return false;
	}
	for (let i = 0;i < from.length;i++) {
		if (from[i].toLowerCase() !== to[i].toLowerCase()) {
			return false;
		}
	}
	return true;
}

export function singleOuterClick(fn: (e: MouseEvent) => boolean) {
	const click = (e: MouseEvent) => {
		if (fn(e)) {
			document.removeEventListener("click", click);
		}
	};
	document.addEventListener("click", click);
}

export function detectWidgetClick(widgetId: string, cb: (inner: boolean) => void): () => void {
	const click = (e: MouseEvent) => cb(locate(e, "dhx_widget_id") === widgetId);
	document.addEventListener("click", click);

	return () => document.removeEventListener("click", click);
}

export function unwrapBox<T>(box: T | T[]): T {
	if (Array.isArray(box)) {
		return box[0];
	}
	return box;
}
export function wrapBox<T>(unboxed: T | T[]): T[] {
	if (Array.isArray(unboxed)) {
		return unboxed;
	}
	return [unboxed];
}

export function isDefined<T>(some: T): boolean {
	return some !== null && some !== undefined;
}

export function range(from: number, to: number): number[] {
	if (from > to) {
		return [];
	}
	const result = [];
	while (from <= to) {
		result.push(from++);
	}
	return result;
}
export function isNumeric(val: any): boolean {
	return !isNaN(val - parseFloat(val));
}

export function downloadFile(data: string, filename: string, mimeType: string = "text/plain"): void {
	const file = new Blob([data], { type: mimeType });
	if (window.navigator.msSaveOrOpenBlob) {
		// IE10+
		window.navigator.msSaveOrOpenBlob(file, filename);
	} else {
		const a = document.createElement("a");
		const url = URL.createObjectURL(file);

		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		setTimeout(function() {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		}, 0);
	}
}